import { createAppWrap } from '../../create_app_wrap';
import commonMixin from './mixin';
import feeCommissionEditer from './_fee-commission-editer-component';
import payMessageEditer from './_pay-message-editer-component';

// 振込先メッセージ編集可のキー
const PAY_MESSAGE_EDIT_ALLOW_KEYS = ['b1', 'b2', 'c1'];

const view = '[data-view="setup-payment"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * データ群
         */
        data() {
            return {
                checkedMethods: [],
            };
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin
        ],
        /**
         * コンポーネント群
         */
        components: {
            // 手数料設定モーダル
            'fee-commission-editer': feeCommissionEditer,
            'pay-message-editer': payMessageEditer,
        },
        watch: {
            // エラーメッセージの行番号をdisp_nameへ変換する
            messages: function (messages) {
                messages.map( (message) => {
                    const index = Number(message.message.replace(/^([0-9]{1,2})(.*)$/, '$1')) - 1;
                    if (index >= 0) {
                        const dispName = this.setup_data.shopPayMethods[index].disp_name;
                        message.message = message.message.replace(/^[0-9]{1,2}/, '「' + dispName + '」');
                    }
                    return message;
                });
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // 対象キーがuseになったら振込先メッセージ編集モーダルを自動で開く
            autoOpenEditPayMessage: function (method) {
                if (method.use && this.isAllowPayMessageEdit(method.key)) {
                    this.editPayMessage(method.key, method.pay_message);
                }
            },
            // 対象のキーが振込先メッセージ編集可能かどうか
            isAllowPayMessageEdit: function (key) {
                return (PAY_MESSAGE_EDIT_ALLOW_KEYS.indexOf(key) != -1);
            },
            // 手数料の編集
            editFeeCommission: function (key, fee, rule, fees) {
                this.$refs.fee_commission_editer.show(key, fee, rule, fees);
            },
            // 入力内容で手数料の上書き
            updateFeeCommission: function (key, fee, rule, fees) {
                let newPayMethods = this.setup_data.shopPayMethods.map(function (method) {
                    if (method.key === key) {
                        // 上書き
                        method.fee_commission = fee;
                        method.fee_rule = rule;
                        method.fee_commissions = fees;
                    }
                    return method;
                });
                this.setup_data.shopPayMethods = newPayMethods;
            },
            // 振込先口座の編集
            editPayMessage: function (key, message) {
                this.$refs.pay_message_editer.show(key, message);
            },
            // 入力内容で振込先口座情報の上書き
            updatePayMessage: function (key, message) {
                let newPayMethods = this.setup_data.shopPayMethods.map(function (method) {
                    if (method.key === key) {
                        method.pay_message = message;
                    }
                    return method;
                });
                this.setup_data.shopPayMethods = newPayMethods;
            },
        },
    });
};

if (document.querySelector(view)) {
    init();
}
